import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    AuthReduxState,
    AUTH_LOCAL_STORAGE_KEY,
    AUTH_SLICE_NAME,
    getEmptyAuthState,
    SET_AUTH_STATE_ACTION_NAME,
} from './auth-types'

export const authSlice = createSlice({
    name: AUTH_SLICE_NAME,
    initialState: getEmptyAuthState(),
    reducers: {
        logoutUser: () => {
            localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
            return getEmptyAuthState()
        },
        [SET_AUTH_STATE_ACTION_NAME]: (_, action: PayloadAction<AuthReduxState>) => {
            return action.payload
        },
    },
})

export default authSlice
